import { render, staticRenderFns } from "./PoliticInfo.vue?vue&type=template&id=72ab37e9&scoped=true"
import script from "./PoliticInfo.vue?vue&type=script&lang=js"
export * from "./PoliticInfo.vue?vue&type=script&lang=js"
import style0 from "./PoliticInfo.vue?vue&type=style&index=0&id=72ab37e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab37e9",
  null
  
)

export default component.exports